module.exports = __webpack_public_path__ + "static/img/newFood5.cafc9bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newFood5.png
// module id = QjUl
// module chunks = 2